export const getItemsFilteredByModifiers = (modifiers, cartItems) =>
  modifiers.reduce((items, modifier) => {
    if (!modifier) {
      return items;
    }

    const itemToFilter = cartItems.filter((item) => {
      const modifiersValues = Object.values(item.items) || [];
      if (modifiersValues.some((modifierId) => modifier.id.toString() === modifierId[0].id?.toString())) {
        return item;
      }
    });
    return [...items, ...itemToFilter];
  }, []);
